module.exports = "/_next/static/images/quick-and-easy-26d48bd9e761bca820139bcea8487bb1.png";